import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const supervisorOTRequestCreate = createAsyncThunk("supervisorOTRequestCreate", async ({ data }, { rejectWithValue }) => {
    try {
        console.log("Supervisor OT data", data);
        const response = await axiosHttp.post(`requests/supervisor/overtime`, data);
        return response.data;

    } catch (err) {
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data);
    }
});

const supervisorOTRequestCreateSlice = createSlice({
    name: "supervisorOTRequestCreateSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    reducers: {
        resetSupervisorOTCreateState: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.error = null;
            state.data = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(supervisorOTRequestCreate.pending, (state, action) => {
            state.isLoading = true;
            state.isError = false;
        });

        builder.addCase(supervisorOTRequestCreate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            
            // Check if all requests failed
            const hasFailed = action.payload?.data?.failed?.length > 0;
            const hasCreated = action.payload?.data?.created?.length > 0;
            
            if (hasFailed && !hasCreated) {
                // All failed
                state.isError = true;
            } else {
                // All success
                state.isError = false;
            }
        });

        builder.addCase(supervisorOTRequestCreate.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});

export const { resetSupervisorOTCreateState } = supervisorOTRequestCreateSlice.actions;
export default supervisorOTRequestCreateSlice.reducer;